module.exports = __webpack_public_path__ + "img/position_default.3dde7108.svg";